import React from 'react';
import styled from '@emotion/styled';
import {Link} from 'gatsby';
import PropTypes from "prop-types";

const SuggestionBar = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  background: ${props => props.theme.colors.white.light};
  box-shadow: ${props => props.theme.shadow.suggestion};
`;
const PostSuggestion = styled.div`
  display: flex;
  align-items: center;
  margin: 1rem 3rem 0 3rem;
`;

const Paper = ({ pageContext }) => {

    // switch paginate module suggetion and createPage module suggention (default paginate one)
    const next = pageContext.next ? pageContext.next : pageContext.nextPagePath;
    const prev = pageContext .prev? pageContext.prev : pageContext.previousPagePath;
    const nextTo = pageContext.next ? next.path :  pageContext.nextPagePath;
    const prevTo = pageContext.prev ? prev.path :  pageContext.previousPagePath;
    const nextTitle = pageContext.next ? next.title :  "次に移動する";
    const prevTitle = pageContext.prev ? prev.title :  "前に移動する";
    return (
        <SuggestionBar>
        <PostSuggestion>
          {prev && (
            <Link to={prevTo}>
              前个单
              <h3>{prevTitle}</h3>
            </Link>
          )}
        </PostSuggestion>
        <PostSuggestion>
          {next && (
            <Link to={nextTo}>
            下个单
              <h3>{nextTitle}</h3>
            </Link>
          )}
        </PostSuggestion>
      </SuggestionBar>
    )
}

// TODO:error生じてる
Paper.propTypes = {
    pageContext:PropTypes.object.isRequired,
}

export default Paper;